import { useApi } from "../../../lib/api"
import { useMemo } from "react"
export function usePlayers(ClientUuid: string | undefined, filters: object) {
  const queryString = Object.entries(filters)
    .map((query) => {
      //Join all query keys values with ','
      const values = query[1]
      //add these values to name of the query
      return query[0] + "=" + values
    })
    .join("&") //join fi

  const [response, error, loading, retry] = useApi(`/clients/` + ClientUuid + `/players-report/Mobile?${queryString}`)
  const data = useMemo(() => response?.data?.array ?? [], [response?.data?.array])

  return useMemo(() => [data, error, loading, retry], [data, error, loading, retry])
}

export function usePlayersTotal(ClientUuid: string | undefined) {
  const [response, error, loading, retry] = useApi(`/clients/` + ClientUuid + `/players-report/stats-heavy`)
  const data = useMemo(() => response?.data ?? [], [response?.data])

  return useMemo(() => [data, error, loading, retry], [data, error, loading, retry])
}

export interface PlayersList {
  country: string
  countryCode: string
  displayName: string
  deviceID: string
  productName: string
  siteUuid: string
  status: number
  subscriptionName: string
  lastConnection: Date
  online: boolean
  externalID: string
}
export interface LengthPlayer {
  all: any
  online: any
  off: any
}
